import Swal from "sweetalert2";
import { getApiErrorMessage } from "./apiError";

export const showApiError = (error, title = "Erro") =>
  Swal.fire({
    icon: "error",
    title,
    html: getApiErrorMessage(error),
  });
